var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-select",
    _vm._b(
      {
        attrs: {
          id: "item-sku-" + _vm.id,
          value: _vm.value,
          name: "sku",
          options: _vm.skus,
          searchable: true,
          "search-delay": 1000,
          loading: _vm.skusLoading,
          "internal-search": false,
          "clear-on-select": false,
          "preserve-search": true,
          "options-limit": _vm.skuOptionsLimit,
          placeholder: "",
          "option-label": "sku",
          "value-field": "sku",
          "track-by": "sku"
        },
        on: {
          input: _vm.onSkuChange,
          search: _vm.skusSearch,
          clear: _vm.skusClear
        },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function(props) {
              return [
                _c("div", { staticClass: "option__desc" }, [
                  _c("span", { staticClass: "option__title" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          props.option.sku + " : " + props.option.description
                        ) +
                        "\n            "
                    )
                  ])
                ])
              ]
            }
          }
        ])
      },
      "form-select",
      _vm.$attrs,
      false
    ),
    [
      _c("template", { slot: "afterList" }, [
        _vm.skusHaveNextPage
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "observe-visibility",
                    rawName: "v-observe-visibility",
                    value: _vm.skusReachedEndOfList,
                    expression: "skusReachedEndOfList"
                  }
                ],
                staticClass: "skus-end-of-list"
              },
              [_vm._v("\n             \n        ")]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }